<template>
    <div class="all transDetail bgff">
       <div class="grid pb30">
            <div class="grid-header clearfix">
                <h2 class="title">关键词对比</h2>
            </div>
            <div class="grid-body mt30">
                <div class="compare clearfix">
                    <p class="compareLi fl" v-for="(item,index) in compareList" :key="index">
                        <span class="close ac fs18 cp" @click="delCompare(index,item.name)">&times;</span>
                        <input type="text" placeholder="" name="" class="input-text ac" v-model="item.name" :size="item.sizeLen" @input="changeText(index)">
                    </p> 
                    <span class="fl" v-if="isShowCompare">
                        <button type="button" class="btn btn-bdblue" @click="addCompare"><i class="fs18">+</i>添加对比</button>
                        <span class="cr27 ml10 cp" @click="sure()">确定</span>
                    </span>
                </div>
                <table width="100%" border="0" cellpadding="0" cellspacing="0" class="table mt25">
                    <colgroup>
                        <col width="14%"> 
                        <col width="24%"> 
                        <col width="24%"> 
                        <col width="20%"> 
                        <col width="18%">
                    </colgroup> 
                    <thead>
                        <tr>
                            <th>&nbsp;</th> 
                            <th>关键词</th> 
                            <th>{{time}}指数</th> 
                            <th>环比</th>
                            <th class="ac">操作</th>
                        </tr>
                    </thead> 
                    <tbody>
                        <tr v-for="(item,index) in tbList" :key="index">
                            <td><i class="icons ml35 " :class="'icon-col'+(index+1)"></i></td> 
                            <td>{{item.name}}</td> 
                            <td>{{item.index}}</td> 
                            <td>{{item.per}}%<i class="icons icon-down" v-if="item.flag==0"></i><i class="icons icon-up" v-if="item.flag==1"></i></td> 
                            <td class="ac">
                               <span class="cp" @click="delCompare(index,item.name)"><i title="删除" class="icons icon-del"></i></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="grid-header pt40 clearfix">
                <h2 class="title">舆论发布指数</h2>
            </div>
            <div class="grid-body mt25">
                <div class="corm clearfix">
                    <span class="element" v-for="(item,index) in dateList" :key="index" @click="choseDete(index)" :class="{'curr':curIndex == index}">{{item}}</span>
                </div>
                <div class="echart-warp mt20 h360">
                    <lineChart ref="lineChart" id="hotEvent" :dataArray="hotEventData" v-if="hotEventData != ''" :colorArr="colorArr" gridBot ="30"></lineChart>
                    <div class="no-data" v-if="nodata.hotEventData"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                </div>
            </div>
       </div>
	</div>
</template>
<script>
import lineChart from '../../components/echart/lineChart1.vue';
export default {
    components:{
        lineChart
    },
    data() {
        return {
            keywords : this.$route.query.keyword,
            compareList:[], //对比列表
            isShowCompare:true,
            curIndex:0,
            tbList:[],
            timeArr:[
                {time:'',value:{}},
                {time:'',value:{}},
                {time:'',value:{}},
            ],
            time:'',
            dateList:['7天','20天'],//,'90天'
            hotEventData:[],
            lineArr:{},
            colorArr:['#2799df','#1fc519','#ffaf30','#ff5757','#27eae3'],
            nodata:{
                hotEventData:false,
            },
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.dataAjax();
            // let keyArr = that.keywords.split(',');
            // keyArr.forEach(ele => {
            //     let tmp = {name:ele,sizeLen:2};
            //     that.compareList.push(tmp);
            // });
        }) 
    },
    watch: {
		$route(){
            let that = this;
            that.keywords = that.$route.query.keyword;
            that.dataAjax();
		},
	},
    methods: {
        choseDete(index){
            let that = this;
            that.curIndex = index;
            that.lineTab();
        },
        dataAjax(){
            let that = this,datas={};
            that.compareList = [];
            that.tbList=[];
            that.hotEventData=[];
            that.$parent.loadModal(true,'正在获取数据...');
            datas = {search:that.keywords}
            that.$api.get('news/index/spread-number',datas,r=>{
                that.$parent.returnCode(r,function(){
                    that.$parent.loadModal(false);
                    let dataArr = r.data.data;
                    let keyname = []; 
                    if(dataArr.length<=1 && dataArr[0].data.length<=0){
                        that.nodata.hotEventData = true;
                        return
                    }else{
                        that.nodata.hotEventData = false;
                    }
                    dataArr.forEach(el => {
                        let data = el.data;
                        let keyArr = data.keyword; 
                        let tmp = {name:keyArr,sizeLen:(keyArr.length*1.8)};
                        that.compareList.push(tmp);
                        let allTime = [];
                        let lineObj = {
                            dataName:[],
                            dateTime:[],
                            dateTime1:[],
                            dateTime2:[],
                            value:[],
                            value1:[],
                            value2:[],
                        };
                        keyname.push(keyArr);
                        for (const key in data.index) {
                            let ele =  data.index[key]
                            let index = key.slice(5);
                            allTime.push(key);
                            lineObj.dateTime.push(key.slice(5));
                            lineObj.dateTime1.push(key.slice(5));
                            lineObj.dateTime2.push(key.slice(5));
                            lineObj.value.push(ele);
                            lineObj.value1.push(ele);
                            lineObj.value2.push(ele);
                        }
                        that.lineArr.dataName = keyname;
                        that.lineArr.datetime = lineObj.dateTime;
                        that.lineArr[keyArr] = lineObj.value;
                        that.timeArr[0].time = lineObj.dateTime.slice(-7);
                        that.timeArr[1].time = lineObj.dateTime1.slice(-20);
                        that.timeArr[2].time = lineObj.dateTime2;
                        that.timeArr[0].value[keyArr] = lineObj.value.slice(-7);
                        that.timeArr[1].value[keyArr] = lineObj.value1.slice(-20);
                        that.timeArr[2].value[keyArr] = lineObj.value2;

                        let tbObj = {name:keyArr};
                        let len = allTime.length;
                        that.time = allTime[len-1];
                        let tbTemp = data.percent[that.time];
                        tbObj.per = tbTemp.per;
                        tbObj.flag = tbTemp.flag;
                        tbObj.index = tbTemp.index;
                        that.tbList.push(tbObj);
                    });    
                    that.lineTab();
                });
            });
        },
        //
        lineTab(){
            let that = this;
            that.lineArr.datetime = [];
            that.lineArr.dataName.forEach(ele => {
                if(that.curIndex==0){
                    that.lineArr.datetime = that.timeArr[0].time;
                    that.lineArr[ele] = that.timeArr[0].value[ele];
                }else if(that.curIndex==1){
                    that.lineArr.datetime = that.timeArr[1].time;
                    that.lineArr[ele] = that.timeArr[1].value[ele];
                }else{
                    that.lineArr.datetime = that.timeArr[2].time;
                    that.lineArr[ele] = that.timeArr[2].value[ele];
                }
            });
            
            that.hotEventData = that.lineArr;
            that.$refs.lineChart.init();
        },
        //添加对比
        addCompare(){
            let that = this;
            let tmp = {name:'',sizeLen:2};
            if(that.compareList.length>4){
                that.$utils.alertText('最多只能添加5个！',200);
                return
            }
            that.compareList.push(tmp);
        },
        changeText(index) {    
           let that = this;
           let txt = that.compareList[index].name.length;
           txt = (txt<2)?1:txt;
            that.compareList[index].sizeLen = parseInt(txt*1.8);
        },
        sure(){
            let that = this,tempArr=[];
            that.compareList.forEach((ele,index) => {
                if(ele.name!=''){
                    tempArr.push(ele);
                }
            });
            that.compareList = tempArr;
            if(that.compareList.length>=5){
                that.isShowCompare = false
            }
            that.reload();
        },
        delCompare(index,name){
            let that = this;
            that.isShowCompare = true;
            that.$delete(that.compareList,index);
            if(name!=''){
                that.reload();
            }
            //that.compareList.splice(index,1)
        },
        reload(){
            let that = this,keyArr=[];
            that.compareList.forEach(ele => {
                keyArr.push(ele.name)
            });
            that.keywords = keyArr.join(",")
            that.$router.push({ path:'/transDetail',query:{keyword:that.keywords}})
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/trans/transDetail.vue